const { sha3_512 } = require('js-sha3');

export default {
    name: 'yuri-login',
    /**
     * @override
     */
    data() {
        return {
            username: '',
            password: '',
            buttonTitle: 'Iniciar sesión',
            loading: false,
            isPasswordVisible: false
        };
    },

    methods: {
        /**
         * Submit credentials from login form to authorize user.
         * @param {Event} e FormEvent
         */
        async onSubmit(e) {
            e.preventDefault();
            this.buttonTitle = 'Accediendo...';
            this.loading = true;
            try {
                await this.$authService.authenticate({
                    grant_type: 'password',
                    username: this.username,
                    password: sha3_512(this.password)
                });
                const res = await this.$usersService.getConfigVars({});
                const configs = {};
                res.data.configurations.forEach(element => {
                    const key_name = element.key_name;
                    configs[key_name] = element.value;
                });
                this.$store.dispatch('configVarsStore/setConfigVars', configs);
                await this.$usersService.getMe();
                this.$router.push({ name: 'dashboard' });
            } catch (err) {
                console.error(err);
                this.buttonTitle = 'Iniciar sesión';
                this.loading = false;
                this.$toast.error('Error de autenticación', 'Las credenciales introducidas no son correctas.');
            }
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.$store.dispatch('yuriMenuStore/reset');
        this.$store.dispatch('formStore/deleteAllForms');
        const entityKeys = ['BOPLCM', 'BOPLEN', 'BOPLFT', 'OBPATH'];
        Object.keys(localStorage).forEach(key => {
            if (!entityKeys.includes(key)) {
                localStorage.removeItem(key);
            }
        });
    }
};
